// Import necessary modules and dependencies
import { ref, getCurrentInstance } from 'vue';
import { getVideoSourceTree } from '@blade-sxp/monitoring-center/api/index';
import { useMonitoringStore } from '@blade-sxp/monitoring-center/store/index';
import { handleClickDevice } from '@blade-sxp/monitoring-center/utils';
// Initialize constants and variables
const store = useMonitoringStore();
// Create useDeviceCommon function that returns an object containing helper functions
export const useDeviceCommon = () => {
    const vm = getCurrentInstance()?.proxy;
    // Initialize reactive reference variable treeData
    const treeData = ref([]);
    // Create asynchronous function getDeviceTree that retrieves device tree data from server
    const getDeviceTree = async () => {
        const res = await getVideoSourceTree();
        if (treeData.value.length === 0) {
            treeData.value = res.trees;
            addNodeName(treeData.value);
        }
        store.updateTreeData(treeData.value);
        return treeData;
    };
    // Create filterNode function for filtering nodes in a tree view
    const filterNode = (value, data) => {
        const nodeNames = [data.name];
        let parentNode = data.parent;
        while (parentNode) {
            nodeNames.push(parentNode.data.name);
            parentNode = parentNode.parent;
        }
        const labels = nodeNames.join(' ').toLowerCase();
        return labels.includes(value.toLowerCase());
    };
    // Create isSelectedItem function to check whether a device is selected
    const isSelectedItem = (id) => {
        return store.selectedDevices.includes(id);
    };
    // Create isDragAble function to check whether a device can be dragged
    const isDragAble = ({ id, children }) => !store.selectedDevices.includes(id) && !children.length;
    // Create handleNodeClick function to handle node selection in the tree view
    const handleNodeClick = (data) => {
        handleClickDevice(data, vm);
    };
    const dragstart = (e, data) => {
        store.updateDragDevice(data);
    };
    const dragend = (e) => {
        store.updateDragDevice(null);
    };
    // Return an object containing helper functions created above
    return { getDeviceTree, filterNode, isSelectedItem, isDragAble, handleNodeClick, dragstart, dragend };
};
// Create a recursive function addNodeName to assign parent node names to each node
const addNodeName = (node) => {
    node.forEach((item) => {
        if (item.children.length > 0) {
            addNodeName(item.children);
            item.children.forEach((itemNode) => {
                itemNode.parentName = item.name;
            });
        }
    });
};
